function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
export var ICStorage = /*#__PURE__*/ function() {
    "use strict";
    function ICStorage() {
        var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "astrox-", _localStorage = arguments.length > 1 ? arguments[1] : void 0;
        _classCallCheck(this, ICStorage);
        this.prefix = prefix;
        this._localStorage = _localStorage;
    }
    var _proto = ICStorage.prototype;
    _proto.get = function get(key) {
        return Promise.resolve(this._getICStorage().getItem(this.prefix + key));
    };
    _proto.set = function set(key, value) {
        this._getICStorage().setItem(this.prefix + key, value);
        return Promise.resolve();
    };
    _proto.remove = function remove(key) {
        this._getICStorage().removeItem(this.prefix + key);
        return Promise.resolve();
    };
    _proto._getICStorage = function _getICStorage() {
        if (this._localStorage) {
            return this._localStorage;
        }
        var ls = typeof window === "undefined" ? typeof global === "undefined" ? typeof self === "undefined" ? undefined : self.localStorage : global.localStorage : window.localStorage;
        if (!ls) {
            throw new Error("Could not find local storage.");
        }
        return ls;
    };
    return ICStorage;
}();
